import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

const t = getTranslation('requests.SchemasError');

export const rejectionReasonSchema = yup
  .string()
  .min(10, t('reasonMinLengthError'))
  .max(500, t('reasonMaxLengthError'));
